import * as React from 'react'
import { Navigate } from 'react-router-dom'

const MagicLinkRedirect = () => {
  const search = window.location.search
  return <Navigate to={`/login/magic-link${search}`} replace />
}

export default MagicLinkRedirect
